import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClientService } from '../services/client.service';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})



export class ClientListComponent implements OnInit {
  public accessRoles: any;
  public scrollDistance = 2;
  public throttle = 10;
  public searchValue = "";
  public searchText = "";





  constructor(
    private router: Router,
    public clientService: ClientService
  ) {
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.clientService.clientMasterListingSearchChange.subscribe((searchTerm: string) => {
      this.onSearchChange(searchTerm);
    });
  }

  ngOnInit(): void {
    this.clientService.isSearchShow = true;
    this.clientService.getListData();
  }

  onSearchChange(str){
    this.searchValue = str;
    if(this.searchValue.length > 1){
      let query = {};
      query['search'] = this.searchValue;
      query['page'] = 1;
      this.clientService.expressListData = [];
      this.clientService.getListData(query);
    }else{
      this.clientService.getListData({page:1});
    }
  }

  addClient(){
    this.router.navigate(['/client-master/request']);
  }

  getDynamicStyleHeader(){
    return this.clientService.expressListHeader.map((va,index) => index%2 ? '2fr' :'1fr').join(' ') + ' 1fr';
  }

  onScroll(){
    if( this.clientService.listPage == 1 || this.clientService.listPage < this.clientService.listTotalPage){
      this.clientService.listPage++;
      let query = {};
      if (this.searchValue && this.searchValue != "") {
        query['search'] = this.searchValue;
      }
      query['page'] = this.clientService.listPage;
      this.clientService.getListData(query);
    }
  }

  viewDetails(uuid){
    if(uuid){
      this.clientService.expressSaveId = uuid;
      this.router.navigate([`/client-master/details/${uuid}`]);
    }
  }

}
